import { render, staticRenderFns } from "./PotensiMainCarousel.vue?vue&type=template&id=885e847e&scoped=true"
import script from "./PotensiMainCarousel.vue?vue&type=script&lang=js"
export * from "./PotensiMainCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885e847e",
  null
  
)

export default component.exports